// src/stores/formStore.js
import { reactive } from 'vue';

export const formStore = reactive({
  responses: {}, // Ex: { age: '25', sex: 'female' }
});

export function resetFormStore() {
  formStore.responses = {};
}

export function getFormStore() {
  return formStore;
}

export function setFormStore(responses) {
  formStore.responses = responses;
}

export function isFormStoreEmpty() {
  return Object.keys(formStore.responses).length === 0;
}